import { makeStyles } from '@mui/styles';

const appBarHeight = 64;

export const useStyles = makeStyles(theme => (
  {
  main: {
    background: theme.palette.common.white,
    minHeight: "100vh",
    marginTop: props => props.noMargin ? 0 : `${appBarHeight + 64}px`
  }
}));
